import { ActionGetFavoritesType, ActionUpdateFavoritesType } from './types';

export const GET_FAVORITES = 'FAVORITES/GET_FAVORITES';
export const GET_FAVORITES_PENDING = `${GET_FAVORITES}_PENDING`;
export const GET_FAVORITES_FULFILLED = `${GET_FAVORITES}_FULFILLED`;
export const GET_FAVORITES_REJECTED = `${GET_FAVORITES}_REJECTED`;

export const getFavorites = (): ActionGetFavoritesType => ({
  type: GET_FAVORITES,
});

export const UPDATE_FAVORITES = 'FAVORITES/UPDATE_FAVORITES';
export const UPDATE_FAVORITES_PENDING = `${UPDATE_FAVORITES}_PENDING`;
export const UPDATE_FAVORITES_FULFILLED = `${UPDATE_FAVORITES}_FULFILLED`;
export const UPDATE_FAVORITES_REJECTED = `${UPDATE_FAVORITES}_REJECTED`;

export const updateFavorites = (asset: string, metricCode: string): ActionUpdateFavoritesType => ({
  type: UPDATE_FAVORITES,
  payload: {
    asset,
    metricCode,
  },
});
